export interface MessageScrollDecision {
  /** How the thread should scroll on this render. */
  behavior: ScrollBehavior;
  /** Whether the thread should now be treated as having been scrolled. */
  markScrolled: boolean;
}

/**
 * Decides how a message thread scrolls when its message list changes.
 *
 * The thread is only considered "scrolled" once there has actually been
 * something to scroll to. Messages load asynchronously, so the first render
 * is empty — marking it scrolled there would make the real first payload
 * animate instead of appearing already at the bottom.
 */
export const getMessageScrollDecision = (
  messageCount: number,
  hasScrolled: boolean
): MessageScrollDecision => ({
  behavior: hasScrolled ? "smooth" : "auto",
  markScrolled: hasScrolled || messageCount > 0,
});
